import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

type Props = PropsWithClassName;

/**
 * This component is intended to be used in the Desktop Application where we use a custom title bar.
 * The component ensures that the window can still be dragged around.
 */
export const DesktopTitlebar: FC<Props> = ({ className }) => {
    return (
        <div className={cn("h-7 w-full flex-shrink-0", className)}>
            <div className="size-full [-webkit-app-region:drag]" />
        </div>
    );
};
